import React from 'react'
import { makeStyles, Container } from '@material-ui/core'
import Slider from "react-slick";
import { NavHashLink } from 'react-router-hash-link';
import bannerImg0 from './img/0.webp'
import bannerImg1 from './img/1.webp'
import bannerImg2 from './img/2.webp'
import bannerImg3 from './img/3.webp'
import bannerImg4 from './img/4.webp'
import bannerImg5 from './img/5.webp'


const useStyles = makeStyles((theme) => ({
    banner: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
        [theme.breakpoints.between('xs', 'sm')]: {
            marginBottom: theme.spacing(2),
        },
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(2),
        }
    },
    img: {
        cursor: 'pointer',
        height: '280px',
        [theme.breakpoints.between('xs', 'sm')]: {
            height: '30vh'
        },
        width: 'auto',
        marginRight: theme.spacing(2)
    },
    div: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    }
}));


const Banner = () => {
    const classes = useStyles();
    const items = [
        <NavHashLink key={0} smooth to='/#W2Wv4YIPIY3zGDCvbGuM' ><img src={bannerImg0} className={classes.img} alt="slider-image-1" /></NavHashLink>,
        <NavHashLink key={1} smooth to='/#CiEizu15ZOZdoROrFaSe' ><img src={bannerImg1} className={classes.img} alt="slider-image-2" /></NavHashLink>,
        <NavHashLink key={2} smooth to='/#YeWRj4BjLPRzlurRl24n' ><img src={bannerImg2} className={classes.img} alt="slider-image-3" /></NavHashLink>,
        <NavHashLink key={3} smooth to='/#e4z2rOUXBfh4igjPwGXd' ><img src={bannerImg3} className={classes.img} alt="slider-image-4" /></NavHashLink>,
        <NavHashLink key={4} smooth to='/#LWq7eqkzVrCG1dmaxJZ1' ><img src={bannerImg4} className={classes.img} alt="slider-image-5" /></NavHashLink>,
        <NavHashLink key={5} smooth to='/#noUU3UBOz3TumHPdWM33' ><img src={bannerImg5} className={classes.img} alt="slider-image-6" /></NavHashLink>
    ];

    var settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        swipeToSlide: true,
        speed: 500,
        adaptiveHeight: true,
        className: classes.div,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    };

    return (
        <Container className={classes.banner} maxWidth="lg">
            <Slider {...settings}>
                {items}
            </Slider>
        </Container>
    )
}


export default Banner

